/** @format */
import { Trans, useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import QueryString from 'qs';
import React from 'react';

import { Query } from '@toucan/common/services/search/types';

import { setSearchParamsForSearchResults } from '@toucan/client/global/nextjs';

import { ConstrainedWrapper } from '@toucan/client/shared/components/constrained-wrapper';
import { Link } from '@toucan/client/shared/components/link';

export function SpellingSuggestion({
    baseQuery,
    originalQuery,
    testId,
}: {
    baseQuery: Query;
    originalQuery:
        | string
        | QueryString.ParsedQs
        | (string | QueryString.ParsedQs)[]
        | undefined;
    testId: string;
}) {
    const router = useRouter();
    const { t } = useTranslation();

    function handlePerformOriginalSearch(): void {
        setSearchParamsForSearchResults(router, {
            q: originalQuery?.toString(),
            page: undefined,
        });
    }

    if (
        !baseQuery.query ||
        !originalQuery ||
        baseQuery.query === originalQuery
    ) {
        return null;
    }

    return (
        <ConstrainedWrapper
            data-testid={`${testId}__suggested-spelling`}
            className="spelling-suggestion-notice"
        >
            <Trans
                components={[
                    <Link key="0" onClick={handlePerformOriginalSearch}>
                        0
                    </Link>,
                ]}
            >
                {t(
                    'Showing results for <strong>{{suggestedTerm}}</strong>. Search instead for <0>{{originalTerm}}</0>.',
                    {
                        suggestedTerm: baseQuery.query,
                        originalTerm: originalQuery,
                    }
                )}
            </Trans>
        </ConstrainedWrapper>
    );
}
